import { navLinks, categories } from "@/mocks/doujin";

export default function Footer() {
  const goTo = (href: string) =>
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-flashlight-line text-lg" />
              </span>
              <span className="font-heading text-xl text-background-50">同人动漫</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-100/80">
              专注于整理与推荐漫画本、插画集、四格漫、条漫、短篇集与画集打包等二次元同人作品，
              分类清晰、浏览方便，与热爱同人的你一起发现更多好作品。
            </p>
            <div className="mt-5 flex gap-3">
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  goTo("#contact");
                }}
                className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-background-800 text-background-100 transition-colors hover:bg-primary-600"
                aria-label="联系我们"
              >
                <i className="ri-mail-line" />
              </a>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  goTo("#contact");
                }}
                className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-background-800 text-background-100 transition-colors hover:bg-primary-600"
                aria-label="社区"
              >
                <i className="ri-chat-3-line" />
              </a>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  goTo("#contact");
                }}
                className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-background-800 text-background-100 transition-colors hover:bg-primary-600"
                aria-label="动态"
              >
                <i className="ri-instagram-line" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50">站内导航</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    onClick={(e) => {
                      e.preventDefault();
                      goTo(l.href);
                    }}
                    className="cursor-pointer text-sm text-background-100/80 transition-colors hover:text-primary-300"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50">作品分类</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {categories.slice(0, 5).map((c) => (
                <li key={c.id}>
                  <a
                    href="#categories"
                    onClick={(e) => {
                      e.preventDefault();
                      goTo("#categories");
                    }}
                    className="cursor-pointer text-sm text-background-100/80 transition-colors hover:text-primary-300"
                  >
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-800 pt-6 sm:flex-row">
          <p className="text-xs text-background-100/60">
            © {new Date().getFullYear()} 同人动漫 · 尊重原创，为热爱而生
          </p>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-background-800 px-4 py-2 text-xs text-background-100 transition-colors hover:bg-primary-600"
          >
            <i className="ri-arrow-up-line" />
            返回顶部
          </button>
        </div>
      </div>
    </footer>
  );
}